import React, { useEffect, useRef, useState } from "react"
import { Notification, NotificationStatus } from '../../../models'
import Empty from '@qc/particle/lib/components/empty'
import NotificationBlock from './NotificationBlock'
import styles from './NotificationPopup.scss'

interface Props {
    notifications: Notification[],
    onVisibilityChange?: (Notification) => void
    onArchive: (notification: Notification) => void
}

enum NotificationPopupTabs {
    open,
    archived
}

const NotificationPopup = ({ notifications, onVisibilityChange, onArchive }: Props) => {
    const [tab, setTab] = useState(NotificationPopupTabs.open)
    const [filteredNotifications, setFilteredNotifications] = useState<Notification[]>([])
    const containmentRef = useRef(null);

    useEffect(() => {
        if (tab === NotificationPopupTabs.open) {
            setFilteredNotifications(notifications.filter(notif => notif.status === NotificationStatus.ACTIVE))
        } else {
            setFilteredNotifications(notifications.filter(notif => notif.status === NotificationStatus.ARCHIVED))
        }
    }, [notifications, tab])

    return (
        <div className={styles.popup}>
            <div data-cy="notif-tabs" className={styles.tabs}>
                <span
                    onClick={() => setTab(NotificationPopupTabs.open)}
                    className={(tab === NotificationPopupTabs.open) ? 'active' : null}
                >
                    Open
                </span>
                <span
                    onClick={() => setTab(NotificationPopupTabs.archived)}
                    className={(tab === NotificationPopupTabs.archived) ? 'active' : null}
                >
                    Archived
                </span>
            </div>
            <div className={styles.content} ref={containmentRef}>
                {filteredNotifications.map((notification, index) => (
                    <NotificationBlock
                      key={`${notification.id}-${index}`}
                      containment={containmentRef}
                      notification={notification}
                      onVisibilityChange={(notif) => {
                        if (onVisibilityChange) onVisibilityChange(notif);
                      }}
                      onArchive={onArchive}
                    />
                ))}
                {(filteredNotifications.length == 0) ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={(tab === NotificationPopupTabs.open)? `You're all caught up!` : `No archived notifications`} /> : null}
            </div>
        </div>
    )
}

export default NotificationPopup;